module.exports = __webpack_public_path__ + "assets/img/5.c1a1baa1.png";